import Login from '@/views/Login.vue';
import store from '@/stores';
import { screen } from '@/router/screenRoutes';

const SUPER_ROLE_ID = 6;

const superOnly = (to, from, next) => {
  const roles = store.state?.user?.userInfo?.roles_ids || [];

  if (roles.includes(SUPER_ROLE_ID)) next();
  else next({ path: '/' });
};

export default [
  // routes
  {
    ...screen('change-password'),
    component: () => import('@/views/AlterPassword.vue'),
  },
  {
    ...screen('login'),
    component: Login,
  },
  {
    ...screen('recover-password'),
    component: Login,
  },
  {
    ...screen('dashboard'),
    component: () => import('@/views/Dashboards/index.vue'),
  },
  {
    ...screen('reports'),
    component: () => import('@/views/Reports.vue'),
  },
  {
    ...screen('edit-user'),
    component: () => import('@/views/EditUser.vue'),
  },
  {
    ...screen('cache-config'),
    component: () => import('@/views/CacheView.vue'),
  },
  {
    ...screen('referral-links'),
    component: () => import('@/views/ReferralLinks.vue'),
  },
  {
    ...screen('limits-consult'),
    component: () => import('@/views/LimitsView.vue'),
  },
  {
    ...screen('terms'),
    component: () => import('@/views/TermsView.vue'),
  },
  {
    ...screen('guidelines'),
    component: () => import('@/views/GuidelinesView.vue'),
  },
  {
    ...screen('collabs'),
    component: () => import('@/views/CollabList.vue'),
  },
  {
    ...screen('do-not-disturb'),
    component: () => import('@/views/DoNotDisturbConsult.vue'),
    props: true,
  },
  {
    ...screen('feature-access'),
    component: () => import('@/views/FeatureAccessGrant.vue'),
    beforeEnter: superOnly,
  },
  {
    ...screen('activation-campaign'),
    component: () => import('@/views/WowMomentList.vue'),
  },
  {
    ...screen('notification-schedules'),
    component: () => import('@/views/NotificationSchedules.vue'),
  },
  {
    ...screen('account-search'),
    component: () => import('@/views/AccountSearch.vue'),
  },

  // redirects (legacy)
  {
    path: '/usuarios/editar',
    redirect: { name: 'edit-user' },
  },
];
